var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.isLogged && !_vm.maintenance ? 'logedin' : '',attrs:{"id":"wrapper"}},[(_vm.isLogged && !_vm.maintenance)?_c('NavigationDrawer'):_vm._e(),_c('v-main',{staticClass:"primary-gradient overflow-hidden",style:({
      'padding-bottom':
        _vm.$vuetify.breakpoint.mobile &&
        ['Signup'].includes[_vm.$router.history.current.name]
          ? '3.5rem'
          : '0',
      ...(['Signup', 'Maintenance'].includes(_vm.$router.history.current.name)
        ? {
            backgroundImage: `url(${require('./assets/img/bg-drawer.jpg')})`,
            backgroundSize: 'cover',
          }
        : {}),
    }),attrs:{"id":"main"}},[_c('div',{staticClass:"container"},[_c('div',{class:{
          'fill-height': !_vm.isLogged || _vm.maintenance,
        }},[_c('div',{staticClass:"content"},[_c('router-view')],1),_c('MessageDialog'),_c('chat-notification'),_c('Toast'),(!_vm.maintenance)?_c('ForceUpdateDialog'):_vm._e()],1)])]),(_vm.isLogged && !_vm.maintenance && _vm.$vuetify.breakpoint.mobile)?_c('NavbarBottom'):_vm._e(),(!_vm.maintenance)?_c('tour',{attrs:{"name":"tourDriverX","steps":_vm.tourSteps,"disabled":_vm.tourDisabled},on:{"next":function($event){_vm.currentTourStep = $event},"finish":_vm.handleTrouFinished}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }